import { IQuery, IQueryMediator } from 'core-ts-types';
import { find } from 'lodash4';
import { APModel } from '../../global/models/ap_model';
export class APProgramDetailsQuery implements IQuery {
  private _result: {
    programName: string;
  };

  constructor(QueryMediator: IQueryMediator, private ngAPModel: APModel) {
    QueryMediator.registerQuery(this, ngAPModel);
  }
  run(): this {
    const programDetails = find(this.ngAPModel.read().program);
    this._result = {
      programName: programDetails.name
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPProgramDetailsQuery', APProgramDetailsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_program_details_query.ts